import parseDomain from '../utils/parseDomain';
import clean from '../utils/clean';
import getObjectProperty from '../utils/getObjectProperty';

export function parseSdCode() {
    const parsedDomain = parseDomain(global.window.location.href, { customTlds: /localhost|\.local/ });
    const subdomain = getObjectProperty(() => parsedDomain.subdomain, null);
    const code = clean(global.window.location.pathname.split('/'))[1];

    // If no subdomain, we expect this kind of url:
    //    https://mysparcit.com/g/SUBDOMAIN-CODE?session_id=blah
    if (!subdomain || subdomain === 'www') {
      return code || null
    }
  
    const filteredSD = subdomain.replace(/\.(xit|xit-test|xit-a-test)$/, '');
    return (filteredSD && code) ? `${filteredSD}-${code || ''}` : null;
}



// WEBPACK FOOTER //
// ./src/config/common.js